import styled, { css } from 'styled-components';

import { Modal } from '../../theme';
import { rem } from '../../utils/index';

export type ModalSizeKey = keyof typeof Modal.Size;
export type ModalSizeValue = (typeof Modal.Size)[ModalSizeKey];

export const ModalSize: Record<ModalSizeKey, ModalSizeValue> = {
  Small: Modal.Size.Small,
  Medium: Modal.Size.Medium,
  Large: Modal.Size.Large,
  XLarge: Modal.Size.XLarge,
};

export const getModalSize = ({ $size = 'Medium' }: { $size?: ModalSizeKey }) => {
  const width = rem(ModalSize[$size] || ModalSize['Medium']);

  return css`
    width: ${width};
    max-width: 90%;
  `;
};

export const StyledWrapper = styled.div`
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Modal};
  background: ${({ theme }) => theme.Modal.OverlayColor};
`;

export const StyledContent = styled.div<{
  $size?: ModalSizeKey;
  $isMobile?: boolean;
  $variant?: 'custom' | 'default';
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ theme, $size, $variant }) => css`
    border-radius: ${rem(theme.Border.Radius.Large)};
    background: ${$variant === 'custom'
      ? theme.Color.NeutralsFixed.Light
      : theme.Components.Panel.Background};
    border: ${rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
    gap: ${rem(theme.Spacing.Size.Medium)};
    box-shadow: 0 0 8px ${theme.Color.Overlay.Light};
    ${getModalSize({ $size })};
  `}
`;

export const StyledContentInnerWrapper = styled.div<{
  $innerPadding: boolean;
}>`
  width: 100%;
  padding: ${({ theme, $innerPadding }) =>
    $innerPadding ? rem(theme.Spacing.Size.MediumLarge) : 0};
`;

export const StyledCloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 100%;
  width: ${({ theme }) => rem(theme.Sizes.X4Large)};
  height: ${({ theme }) => rem(theme.Sizes.X4Large)};
  margin-left: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  border-radius: 50%;
  cursor: pointer;
  background: ${({ theme }) => theme.Color.Overlay.Default};
  transition: background-color ${({ theme }) => theme.Transition.Timing.In};

  &:hover {
    background: ${({ theme }) => theme.Color.Neutrals.Dark};
  }
`;
